import type { VertexObject } from '../types';

/** Extract URL string from a vertex object or string */
export function getVertexUrl(v: VertexObject | string | null | undefined): string | null {
  if (!v) return null;
  if (typeof v === 'string') return v;
  return v.rendered ?? null;
}
